import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../../services/api.js";
import { useNavigate } from "react-router-dom";

const AppContext = createContext();

export const AppProvider = ({ children }) => {

  const navigate = useNavigate();

  const [appState, setAppState] = useState(() => {
    const stored = localStorage.getItem("iContasApp");

    return stored
      ? JSON.parse(stored)
      : {
        codusuario: 0,
        codusuarionuvem: 0,
        nome: "",
        cpf: "",
        logado: false,
        versao: "0.0.1",
        token: "",
        trial: false,
        saldovisivel: true,
        statusconta: "",
        trialfim: "",
        assinaturafim: "",
        dtultsinccat: "",
        dtultsinclan: "",
        dtultsincmet: "",
        dtultsincpes: "",
        dtultsincsal: ""
      };
  });

  // =========================
  // SALVAR LOCALSTORAGE
  // =========================

  useEffect(() => {
    localStorage.setItem("iContasApp", JSON.stringify(appState));
  }, [appState]);

  // =========================
  // VERIFICAR ACESSO
  // =========================

  useEffect(() => {

    if (!appState.logado || !appState.codusuarionuvem) return;

    verificarAcesso(appState.codusuarionuvem);

  }, [appState.logado, appState.codusuarionuvem]);

  // =========================
  // FUNÇÃO DE VERIFICAÇÃO
  // =========================

  async function verificarAcesso(codusuario) {

    try {

      const response = await api.get("v1/verificaracesso", {
        params: { codusuario }
      });

      const data = response.data;

      setAppState((prev) => ({
        ...prev,
        statusconta: data.statusconta,
        trialfim: data.trialfim,
        assinaturafim: data.assinaturafim
      }));

      if (data.acesso === "N") {
        navigate("/assinatura")
      }

    } catch (err) {
      console.error("Erro ao verificar acesso:", err.response || err.message || err);
    }

  }

  // =========================
  // ATUALIZAÇÕES
  // =========================

  const updateField = (field, value) => {
    setAppState((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  const updateLogin = (dados) => {
    setAppState((prev) => ({
      ...prev,
      ...dados,
      logado: true
    }));
  };

  const logout = () => {

    setAppState({
      codusuario: 0,
      codusuarionuvem: 0,
      nome: "",
      cpf: "",
      logado: false,
      versao: "0.0.1",
      token: "",
      trial: false,
      saldovisivel: true,
      statusconta: "",
      trialfim: "",
      assinaturafim: "",
      dtultsinccat: "",
      dtultsinclan: "",
      dtultsincmet: "",
      dtultsincpes: "",
      dtultsincsal: ""
    });

    localStorage.removeItem("iContasApp");

  };

  return (
    <AppContext.Provider
      value={{
        ...appState,
        updateField,
        updateLogin,
        logout
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);